var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitRegiments3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 58,
    viewBox: "0 0 139 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.712 -0.383669H281.963V58.184H138.712V-0.383669Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 3C125.359 3 137 14.6407 137 29C137 43.3594 125.359 55 111 55C96.6406 55 85 43.3594 85 29C85 14.6407 96.6406 3 111 3Z",
    stroke: "#1A1A18",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5572 36.7226L29.8052 38.2105L29.1892 40.2746C25.9411 40.0826 22.3331 39.9786 18.3812 39.9786C13.7491 39.9786 10.1491 40.1464 7.58919 40.4666L7.25317 37.7306C7.79704 37.7306 8.19732 37.7627 8.44519 37.8266C8.76532 37.7627 9.19732 37.7306 9.74919 37.7306C11.1892 37.5786 12.5332 37.0666 13.7732 36.2026C15.0212 35.3386 16.0931 34.2666 17.0131 32.9866C17.9251 31.7067 18.6292 30.3707 19.125 28.9866C19.6213 27.5946 19.8692 26.3546 19.8692 25.2506C19.8692 23.7467 19.509 22.4585 18.781 21.3625C18.061 20.2748 17.0452 19.7305 15.7412 19.7305C14.4052 19.8265 13.3333 20.3628 12.5252 21.3387C11.7172 22.3226 11.301 23.6586 11.2772 25.3466C11.3093 25.6029 11.3252 25.9868 11.3252 26.4906H9.93319C9.93319 23.6268 10.5493 21.2585 11.781 19.3945C13.0052 17.5308 14.8931 16.5546 17.4212 16.4666C18.541 16.4666 19.549 16.7387 20.4289 17.2746C21.3013 17.8106 21.9971 18.5706 22.5009 19.5386C23.0051 20.5148 23.2772 21.6189 23.3252 22.8506C23.3252 24.2667 23.101 25.5866 22.6612 26.8107C22.2212 28.0426 21.6289 29.1946 20.8931 30.2826C20.1572 31.3787 19.3091 32.4665 18.3412 33.5546C17.3812 34.6427 16.4533 35.6987 15.5572 36.7226Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7679 33.9602L84.0959 32.0402C86.7038 28.7361 89.1438 25.3281 91.4078 21.8082C93.6717 18.2964 95.8718 14.5524 98.016 10.5845L101.664 11.1522L100.696 30.6482L107.472 30.1682L106.416 32.816L100.416 32.9121L99.9839 41.6402L96.384 43.8002C96.8318 40.4639 97.0559 36.8882 97.0559 33.0962H94.896C92.1917 33.0962 88.8078 33.3842 84.7679 33.9602ZM97.9199 14.6162L87.304 30.6482H97.0559L97.9199 14.6162Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 16L51.6815 19.5786L58.2424 23.1569L51.6814 27.2358L45.1814 30.7358L38.5605 26.7358L32 23L38.5605 19.5786L45.1211 16Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5404 37.6996L32.3606 30.468L32.1814 23.2358L38.6814 26.7358L45.1812 30.7358V37.7358V45.2358L38.8609 41.4677L32.5404 37.6996Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1814 30.7358L51.8609 27.0039L58.1814 23.2358L58.0018 30.4681L57.8224 37.7001L51.5019 41.4677L45.1814 45.2358V38.2358V30.7358Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0607 31.0607C87.6464 30.4749 87.6464 29.5251 87.0607 28.9393L77.5147 19.3934C76.9289 18.8076 75.9792 18.8076 75.3934 19.3934C74.8076 19.9792 74.8076 20.9289 75.3934 21.5147L83.8787 30L75.3934 38.4853C74.8076 39.0711 74.8076 40.0208 75.3934 40.6066C75.9792 41.1924 76.9289 41.1924 77.5147 40.6066L87.0607 31.0607ZM61 31.5H86V28.5H61V31.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.121 14L129.681 17.5786L136.242 21.1569L129.681 25.2358L123.181 28.7358L116.561 24.7358L110 21L116.561 17.5786L123.121 14Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.54 35.6996L110.361 28.468L110.181 21.2358L116.681 24.7358L123.181 28.7358V35.7358V43.2358L116.861 39.4677L110.54 35.6996Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.181 28.7358L129.861 25.0039L136.181 21.2358L136.002 28.4681L135.822 35.7001L129.502 39.4677L123.181 43.2358V36.2358V28.7358Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-478 -330)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitRegiments3);
export default __webpack_public_path__ + "static/media/recruit_regiments3.548784c41ba7b4626e93625f608baa56.svg";
export { ForwardRef as ReactComponent };